// extracted by mini-css-extract-plugin
export default {"root":"hYoKU6kk","logo":"foo5FXhD","collapsed":"LYUp6zes","right":"IqgZIZyv"};